module.exports = "../dist/img/upper-banner-21.3587.jpg";